import SoundEngine from './SoundEngine';

export default class CallForHelp extends SoundEngine {
  on = false
  interval = null
  mainGain = null

  constructor (context) {
    super(context);

    this.mainGain = this.fx.gain();
    this.mainGain.connect(this.output);
  }

  toggle () {
    if (this.on) {
      clearInterval(this.on);
      this.on = false;
      this.mainGain.gain.linearRampToValueAtTime(0, this.now + 0.1);
    } else {
      this.on = true;
      this.doubleRadar();
      this.on = setInterval(() => this.doubleRadar(), 3000);
      this.mainGain.gain.linearRampToValueAtTime(1, this.now + 0.1);
    }
  }

  doubleRadar () {
    this.radar();
    setTimeout(() => this.radar(), 1000);
  }

  radar () {
    const verb = this.fx.verb(1);
    const delay = this.fx.delay(0.25, 0.5);

    const aOsc = this.osc.triangle();
    const aGain = this.fx.gain();
    const aFilter = this.fx.filter();

    const aLength = 0.3;
    aOsc.frequency.setValueAtTime(523.25, this.now);
    aGain.gain.setValueAtTime(0.7, this.now);
    aGain.gain.linearRampToValueAtTime(0.0001, this.now + aLength);

    aOsc.connect(aGain);
    aGain.connect(aFilter);
    aFilter.connect(this.mainGain);
    aFilter.connect(verb);

    const verbGain = this.fx.gain();
    verbGain.gain.setValueAtTime(1, this.now);
    verb.connect(verbGain);
    verbGain.connect(this.mainGain);

    const delayGain = this.fx.gain();
    delayGain.gain.setValueAtTime(1, this.now);
    aFilter.connect(delay);
    delay.connect(delayGain);
    delayGain.connect(this.mainGain);

    aOsc.start();
    aOsc.stop(this.now + aLength);
  }
}
